import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pending-task-error-widget',
  templateUrl: './pending-task-error-widget.component.html',
  styleUrls: ['./pending-task-error-widget.component.scss']
})
export class PendingTaskErrorWidgetComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
